import { IPayloadRequestData, PayloadType } from 'APP/model/message/messageModel.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface IPayloadParams {
  message?: ChatMessage;
  payloadType: PayloadType;
}

export class Payload {
  payloadType: PayloadType;
  message: ChatMessage | null;

  constructor(data: IPayloadParams) {
    this.payloadType = data.payloadType;
    this.message = data.message || null;
  }

  get typeDescription(): string {
    return 'Message';
  }

  get isSystem(): boolean {
    return false;
  }

  get isCall(): boolean {
    return false;
  }

  get canBeDelete(): boolean {
    return true;
  }

  toJSON(): IPayloadRequestData {
    return {
      payloadType: this.payloadType,
    };
  }
}
